import React from "react";
import { Glyphicon, Badge } from "react-bootstrap";
import ContactsList from "./ContactsList";

function ContactAvatar({ contact, showName, onRemoveClick }) {
  return (
    <div className="contact-avatar">
      {renderImage(contact)}
      {renderRemoveElement(onRemoveClick, contact.id)}
      {renderName(contact.name, showName)}
    </div>
  );
}

function renderImage(contact) {
  return (
    <div className="text-center">
      <div className="online-badge">
        <img
          width={50}
          height={50}
          className="img-circle"
          src={contact.profilePhotoUrl}
          alt="Image"
        />
        <div className={`cute-badge in-badge ${contact.online ? "on" : "off"}`} />
      </div>
    </div>
  );
}

function renderRemoveElement(onRemoveClick, contactId) {
  if (onRemoveClick) {
    return (
      <Badge
        className="remove"
        onClick={() => {
          onRemoveClick(contactId);
        }}
      >
        <Glyphicon glyph="remove" />
      </Badge>
    );
  } else {
    return "";
  }
}

function renderName(name, showName) {
  if (showName) {
    return <div className="name text-center text-muted">{name}</div>;
  } else {
    return "";
  }
}

export default ContactAvatar;
